import { Component, OnInit, Input } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { JssStylingService } from '../../JssStylingService';
import { IAccordionItemDataModel } from '../../models/accordion-item.datamodel';

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.scss']
})
export class FaqsComponent implements OnInit {
  @Input() rendering: ComponentRendering;
  @Input() expanded: boolean = false;
  jssStylingService: JssStylingService;
  dynamicClass: string;
  cards: IAccordionItemDataModel[] = [];
  simpleItems: any[] = [];
  public simpleAccordion :boolean;
  faqsShowMore: boolean = false;

  constructor(jssStylingService: JssStylingService) {
    this.jssStylingService = jssStylingService;
  }

  ngOnInit() {
    // remove this after implementation is done
    console.log('faqs component initialized with component data', this.rendering);
    this.dynamicClass = this.jssStylingService.getComponentClass(this.rendering);

    this.simpleAccordion = (this.rendering.fields.Items as any).some((item:any) => item.fields.Answer !== undefined);
    this.simpleItems = (this.rendering.fields.Items as any).filter((item:any) => item.fields.Answer !== undefined);
    let loopLength = (this.rendering.fields?.PageSize as any).value ? (this.rendering.fields?.PageSize as any).value : 5;
    // console.log('simpleItems: ', this.simpleItems);
    if((this.rendering.fields.Items as any)?.length > 0 && this.simpleAccordion){ 
      for (let i = 0; i < loopLength; i++) {
        if (this.simpleItems[i]) {
          let card:IAccordionItemDataModel = {
            Answer: this.simpleItems[i]?.fields?.Answer?.value,
            Question: this.simpleItems[i]?.fields?.Question?.value
          } 
          this.cards.push(card);
        }
        this.faqsShowMore = this.simpleItems.length > this.cards.length;
      }
    }
    // console.log('this.cards: ', this.cards);
  }

  showMore($event: any) {
    $event.preventDefault();
    if(!this.faqsShowMore) {
      window.location.href = (this.rendering.fields?.Link as any).value.href ? (this.rendering.fields?.Link as any).value.href : '';
      return;
    }
    let loopLength =
      (this.rendering?.fields?.PageSize as any)?.value > 0
        ? (this.rendering?.fields?.PageSize as any)?.value + this.cards.length
        : 5 + this.cards.length;
    for (let i = this.cards.length; i < loopLength; i++) {
      if (this.simpleItems[i]) {
        let card:IAccordionItemDataModel = {
          Answer: this.simpleItems[i]?.fields?.Answer?.value,
          Question: this.simpleItems[i]?.fields?.Question?.value
        } 
        this.cards.push(card);
      } else {
        break;
      }
    }
    this.faqsShowMore = this.simpleItems.length > this.cards.length;
  }

}